import {inject, Injectable} from '@angular/core';
import {QuarantineApiService} from "@app/quarantine/services/quarantine.api.service";
import {map} from "rxjs/operators";
import {OrganisationInterface, OrganisationsInterface} from "@app/quarantine/intrfaces/quarantine.interface";
import {BehaviorSubject, filter} from "rxjs";
import {DocumentTypeInterfaces} from "@app/quarantine/intrfaces/quarantine-form.interface";

@Injectable({
  providedIn: 'root'
})
export class HelpersQuarantineService {
  quarantineApiService = inject(QuarantineApiService);

    $organisations = new BehaviorSubject<OrganisationInterface[]>([]);


  constructor() {
      this.quarantineApiService.getOrganisations()
          .subscribe((data) => {
              this.$organisations.next(data);
          });
  }
  
  statusTypes:{ [key: string]: string } = {
    DRAFT: 'Чернетка',
    CONFIRMED: 'Підтверджено',
    CANCELLED: 'Скасовано'
  };
  placementTypes:{ [key: string]: string } = {
    QUARANTINE_PLACEMENT: 'Розміщення у карантин',
    QUARANTINE_REMOVAL: 'Зняття з карантину'
  };
  
  quarantineOrganizationsType: { [key: string]: string }[] = [
    {
      value: 'ALL',
      description: 'Всі заклади'
    },
    {
      value: 'ALL_SUBORDINATED',
      description: 'Всі підлеглі заклади'
    },
    {
      value: 'OTHER',
      description: 'Iнше'
    },
  ]
  docTypes: DocumentTypeInterfaces = [
      {
        name : "DLS_ORDER",
        nameUa: "Розпорядження ДержЛікСлужби"
      },
      {
        name : "MOZ_ORDER",
        nameUa: "Наказ МОЗ"
      },
      {
        name : "MPU_LETTER",
        nameUa: "Лист ДП МЗУ"
      },
      {
        name : "OTHER",
        nameUa: "Інше"
      },
  ]
  errorMessages = {
    500: 'Сервер не доступний. Спробуйте пізніше, або зверніться до адміністратора.',
    401: 'В доступі відмовлено. Зверніться до адміністратора',
    403: 'В доступі відмовлено. Зверніться до адміністратора',
    409: ''
  }
  
  getOrganisation(id: number) {
      return this.$organisations
          .pipe(
              filter((data: OrganisationInterface[]) => data.length !== 0),
              map((data: OrganisationInterface[]) => {
                  return data.find(o => o.id ===  id);
              })
          )
  }
}
